<banner class="banner"
    [visible]="showConfirmationBanner"
    [message]="fedRampMessage"
    type="confirmation"
    [@expand]
    (yes)="onClickYes()"
    (no)="navigateToClouds()">
</banner>
<app-tabs *ngIf="tabSession" [tabs]="tabs" [activeTab]="activeTab" (closeTab$)="onCloseTab($event)" (tabClick$)="onTabClick($event)"></app-tabs>
<div class="tabContents" *ngIf="!showConfirmationBanner"><router-outlet #tabContents></router-outlet></div>
<div class="container" *ngIf="error">
  <p class="text error">{{error}}</p>
</div>
<app-default-loading-icon *ngIf="loading"></app-default-loading-icon>
